module.exports = __webpack_public_path__ + "img/csv 1.45254066.svg";